import { Stack, styled, Typography, useTheme } from "@mui/material";
import React from "react";
import { CSVLink } from "react-csv";
import Tooltip from "@hyro-components/Tooltip";
import { DOWNLOAD_BTN_SIZES, DOWNLOAD_BTN_VARIANTS } from "@consts";
import { escapeCsvCell, sanitizeCsvRows } from "@utils";

import DownloadIcon from "../../icons/DownloadIcon";

const CSVLinkButton = styled(CSVLink)(({ disabled, variant, size, theme }) => ({
  textDecoration: "none",
  backgroundColor: theme.palette.system[0],
  ...(variant === DOWNLOAD_BTN_VARIANTS.OUTLINED && {
    border: "1px solid rgba(45, 44, 68, 0.24)",
    borderRadius: "8px",
    padding: size === DOWNLOAD_BTN_SIZES.LARGE ? "9px" : "7px",
    "&:hover": {
      backgroundColor: "#EBEBFD",
      borderColor: "#7583F7"
    }
  }),
  ...(disabled && {
    pointerEvents: "none",
    cursor: "default",
    border: "1px solid rgba(45, 44, 68, 0.12)",
    backgroundColor: theme.palette.grey[50]
  })
}));

const DownloadButton = ({ fileName, fileHeaders, fileData, buttonText = "", disabled, variant = DOWNLOAD_BTN_VARIANTS.TEXT, size = DOWNLOAD_BTN_SIZES.MEDIUM, testId }) => {
  const [hover, setHover] = React.useState(false);
  const theme = useTheme();
  // Neutralize CSV formula-injection (CWE-1236) before handing to react-csv.
  const safeData = Array.isArray(fileData) ? sanitizeCsvRows(fileData) : fileData;
  const safeHeaders = Array.isArray(fileHeaders)
    ? fileHeaders.map((header) =>
      header && typeof header === "object"
        ? { ...header, label: escapeCsvCell(header.label) }
        : escapeCsvCell(header))
    : fileHeaders;
  return (
    <Tooltip title={disabled || Boolean(buttonText) ? "" : "Download"}>
      <CSVLinkButton
        filename={`${fileName}.csv`}
        data={safeData}
        headers={safeHeaders}
        disabled={disabled}
        variant={variant}
        size={size}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        data-testid={testId}>
        <Stack
          gap={1}
          direction='row'
          alignItems='center'
        >
          <DownloadIcon stroke={disabled ? theme.palette.text[600] : hover ? theme.palette.primary[500] : theme.palette.system[700]} />
          {!!buttonText && <Typography
            sx={{ color: disabled ? theme.palette.text[600] : hover ? theme.palette.primary[500] : theme.palette.text[800] }}
            variant='buttonMedium'>
            {buttonText}
          </Typography>}
        </Stack>
      </CSVLinkButton>
    </Tooltip>
  );
};

export default DownloadButton;
